<!-- Header con gradiente -->
<div style="background: linear-gradient(135deg, #1C593D, #059669); padding: 20px 24px; display: flex; align-items: center; justify-content: space-between;">
  <div style="display: flex; align-items: center; gap: 12px;">
    <div style="display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; background: rgba(255,255,255,0.2); border-radius: 10px;">
      <mat-icon style="color: white; font-size: 22px; width: 22px; height: 22px; flex-shrink: 0;">{{ esUpdate ? 'edit' : 'person_add' }}</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; color: white; font-size: 1.15rem; font-weight: 700;">{{ esUpdate ? 'Editar Beneficiario' : 'Registrar Beneficiario' }}</h2>
      <p style="margin: 2px 0 0; color: rgba(255,255,255,0.8); font-size: 0.78rem;">Beneficiario criptomoneda</p>
    </div>
  </div>
  <button type="button" (click)="cancel()"
    style="display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; background: rgba(255,255,255,0.2); border: none; border-radius: 8px; cursor: pointer; transition: background 0.2s;"
    onmouseover="this.style.background='rgba(255,255,255,0.3)'" onmouseout="this.style.background='rgba(255,255,255,0.2)'">
    <mat-icon style="color: white; font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;">close</mat-icon>
  </button>
</div>

<!-- Contenido scrollable -->
<div style="padding: 24px; max-height: 60vh; overflow-y: auto;">

  <!--
    Motivo del último intento fallido. Persiste dentro del diálogo en vez de
    irse con un Swal: el cliente lo necesita a la vista mientras corrige.
  -->
  <div *ngIf="mensajeError" role="alert" aria-live="assertive"
    style="display: flex; align-items: flex-start; gap: 10px; margin-bottom: 16px; padding: 12px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px;">
    <mat-icon style="color: #dc2626; font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;">error_outline</mat-icon>
    <span style="color: #991b1b; font-size: 0.85rem; line-height: 1.45;">{{ mensajeError }}</span>
  </div>

  <!--
    Ninguna red del selector está encendida. Se avisa antes de que el cliente
    llene el formulario para nada.
  -->
  <div *ngIf="sinRedesDisponibles && !mensajeError" role="status"
    style="display: flex; align-items: flex-start; gap: 10px; margin-bottom: 16px; padding: 12px 14px; background: #fffbeb; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px;">
    <mat-icon style="color: #b45309; font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;">pause_circle</mat-icon>
    <span style="color: #92400e; font-size: 0.85rem; line-height: 1.45;">{{ avisoSinRedes }}</span>
  </div>

  <form [formGroup]="formCuenta" (ngSubmit)="guardarBeneficiario()" *ngIf="formCuenta">
    <div style="display: flex; flex-direction: column; gap: 16px;">

      <!-- Nombre -->
      <mat-form-field appearance="outline" class="modern-field w-full">
        <mat-label>Nombres</mat-label>
        <input matInput formControlName="nombre" type="text" pattern="[ a-zA-Z]*" (keypress)="soloAlfabetico($event)">
        <mat-icon matPrefix style="color: #6b7280; margin-right: 8px; flex-shrink: 0;">person</mat-icon>
        <mat-error *ngIf="formCuenta.get('nombre')?.hasError('required')">¡Este campo es obligatorio!</mat-error>
        <mat-error *ngIf="formCuenta.get('nombre')?.hasError('maxlength')">Los caracteres no pueden ser mayor a 40</mat-error>
        <mat-error *ngIf="formCuenta.get('nombre')?.hasError('tildesOrSpecialChars')">No se permiten letras con tildes o caracteres especiales.</mat-error>
      </mat-form-field>

      <!-- Apellido -->
      <mat-form-field appearance="outline" class="modern-field w-full">
        <mat-label>Apellidos</mat-label>
        <input matInput formControlName="apellido" type="text" pattern="[ a-zA-Z]*" (keypress)="soloAlfabetico($event)">
        <mat-icon matPrefix style="color: #6b7280; margin-right: 8px; flex-shrink: 0;">person_outline</mat-icon>
        <mat-error *ngIf="formCuenta.get('apellido')?.hasError('required')">¡Este campo es obligatorio!</mat-error>
        <mat-error *ngIf="formCuenta.get('apellido')?.hasError('maxlength')">Los caracteres no pueden ser mayor a 40</mat-error>
        <mat-error *ngIf="formCuenta.get('apellido')?.hasError('tildesOrSpecialChars')">No se permiten letras con tildes o caracteres especiales.</mat-error>
      </mat-form-field>

      <!--
        Red. Al crear se elige: las pausadas se ven pero no se pueden elegir.
        Al editar es la del beneficiario y queda fija (una dirección de una
        red no sirve en otra).
      -->
      <mat-form-field *ngIf="!esUpdate" appearance="outline" class="modern-field w-full">
        <mat-label>Red</mat-label>
        <mat-select formControlName="red">
          <mat-option *ngFor="let opcion of opcionesRed" [value]="opcion.red.id" [disabled]="!opcion.activa">
            {{ opcion.red.etiqueta }}{{ opcion.activa ? '' : ' (pausada)' }}
          </mat-option>
        </mat-select>
        <mat-icon matPrefix style="color: #6b7280; margin-right: 8px; flex-shrink: 0;">token</mat-icon>
        <mat-hint *ngIf="soloRedBinance">Para este envío solo sirven wallets de la red Tron (TRC20).</mat-hint>
        <mat-error *ngIf="formCuenta.get('red')?.hasError('required')">Elegí una red.</mat-error>
        <mat-error *ngIf="formCuenta.get('red')?.hasError('redPausada')">Esta red está pausada por el momento.</mat-error>
      </mat-form-field>

      <div *ngIf="esUpdate"
        style="display: flex; align-items: center; gap: 12px; padding: 12px 14px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px;">
        <mat-icon style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;">token</mat-icon>
        <div style="flex: 1; min-width: 0;">
          <span style="display: block; font-size: 0.72rem; font-weight: 600; color: #6b7280;">Red</span>
          <span style="display: block; font-size: 0.9rem; font-weight: 700; color: #111827;">
            {{ redSeleccionada?.etiqueta || data?.beneficiario?.medioCriptomoneda_descripcion }}
          </span>
        </div>
        <span *ngIf="redFijaPausada"
          style="padding: 2px 10px; border-radius: 12px; font-size: 0.7rem; font-weight: 700; background: #fef3c7; color: #92400e; border: 1px solid #fde68a; flex-shrink: 0;">
          Pausada
        </span>
        <mat-icon title="La red de un beneficiario no se cambia" style="color: #9ca3af; font-size: 18px; width: 18px; height: 18px; flex-shrink: 0;">lock</mat-icon>
      </div>
      <p *ngIf="redFijaPausada" style="margin: -8px 0 0; font-size: 0.78rem; color: #92400e; line-height: 1.4;">
        Esta red está pausada por el momento: podés editar el beneficiario, pero no
        vas a poder enviarle hasta que se reactive.
      </p>

      <!-- Wallet: etiqueta, ayuda y formato según la red -->
      <mat-form-field appearance="outline" class="modern-field w-full">
        <mat-label>Wallet {{ redSeleccionada?.etiquetaCorta }}</mat-label>
        <input matInput formControlName="medioRecepcion" type="text" autocomplete="off" autocapitalize="off" spellcheck="false"
          [placeholder]="redSeleccionada?.placeholder || ''">
        <mat-icon matPrefix style="color: #6b7280; margin-right: 8px; flex-shrink: 0;">account_balance_wallet</mat-icon>
        <mat-hint *ngIf="redSeleccionada">La dirección {{ redSeleccionada.ayuda }}.</mat-hint>
        <mat-error *ngIf="formCuenta.get('medioRecepcion')?.hasError('required')">¡Este campo es obligatorio!</mat-error>
        <!-- El motivo del validador: el mismo texto que respondería wallet-back -->
        <mat-error *ngIf="formCuenta.get('medioRecepcion')?.hasError('direccionInvalida')">
          {{ formCuenta.get('medioRecepcion')?.getError('direccionInvalida') }}
        </mat-error>
      </mat-form-field>

      <!-- Comisión de red (04/11/2026): se avisa al cargar la dirección, en cualquier red -->
      <div class="aviso-comision-red" role="note"
        style="display: flex; align-items: flex-start; gap: 10px; padding: 12px 14px; background: #fef3c7; border: 1px solid #fcd34d; border-radius: 12px;">
        <mat-icon style="color: #92400e; font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;">info_outline</mat-icon>
        <span style="color: #78350f; font-size: 0.85rem; line-height: 1.5;">
          <b>Comisión de red:</b> si esta dirección no es de Binance, cada retiro tendrá una comisión variable,
          que actualmente es de <b>{{ comisionRedUsdt }} USDT</b>. Las direcciones de Binance no tienen este cargo.
        </span>
      </div>

    </div>
  </form>
</div>

<!-- Footer -->
<div style="padding: 16px 24px; border-top: 1px solid #f3f4f6; display: flex; justify-content: flex-end; gap: 12px;">
  <button type="button" (click)="cancel()"
    style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s;"
    onmouseover="this.style.background='#f9fafb'" onmouseout="this.style.background='white'">
    Cancelar
  </button>
  <!--
    Sin `[disabled]`: el botón gris no explicaba nada y era la mitad del
    "hago clic y no pasa nada". Ahora siempre se puede clickear y es
    `guardarBeneficiario()` quien marca los campos y dice qué falta.
  -->
  <button type="button" (click)="guardarBeneficiario()"
    style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white; flex-shrink: 0;">save</mat-icon>
    {{ esUpdate ? 'Actualizar' : 'Guardar' }}
  </button>
</div>
